import * as React from 'react';

import './RSearchBar.scss';

export default class RSearchBar extends React.Component<any, any> {
  public render() {
    const { t } = this.props;
    return (
      <div className="rp-rsearch-bar">
        <div className="rp-rsearch-bar--text">
          <input
            className="search-input reset-text-input"
            type="text"
            placeholder={t('common.searchByKeyword')}
            onChange={this.props.handleChange}
            onKeyPress={this.props.handleChange}
            value={this.props.value}
            disabled={this.props.disabled}
          />
        </div>
        <div
          className="rp-rsearch-bar--button"
          onClick={this.props.handleChange}
        >
          <i className="rpds-search search-icon" />
          <p className="search-label">{t('common.search')}</p>
        </div>
      </div>
    );
  }
}
